import { useFliptBoolean } from "@flipt-io/flipt-client-react";
import useUser from "~/contexts/user";
import { useCanUseAIAgents } from "./useCanUseAIAgents";

// Gates the help popover: `use:agents` is what the analysis-agent enforces, and
// the flag picks who among those users sees it.
export function useCanUsePlatformAgent(): boolean {
  const user = useUser();
  const canUseAgents = useCanUseAIAgents();
  const flagEnabled = useFliptBoolean("platform-agent", false, user?.email);
  return canUseAgents && flagEnabled;
}
